import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

const buildTransactionParamsPayload = (oParams) => {
  const {
    start = '',
    end = '',
  } = oParams.dates;

  const {
    shipment_order_volume_state_code = [],
    logistic_provider = [],
    performance_lp = [],
    platform = [],
    sales_channel = [],
    delivery_method = [],
    uf = [],
    searchText = '',
  } = oParams.slcFilter;

  const {
    perPage = 50,
    current = 1,
  } = oParams.paginate;

  const { isTest } = oParams;

  const formatDateStart = Moment(start).toISOString();
  const formatDateEnd = Moment(end).add(1, 'days').subtract(1, 'hours').add(59, 'minutes')
  .toISOString();

  return {
    isTest,
    start: formatDateStart,
    end: formatDateEnd,
    query: String,
    shipmentOrderVolumeState: shipment_order_volume_state_code,
    logisticProvider: logistic_provider,
    performanceLp: performance_lp,
    platform,
    salesChannel: sales_channel,
    deliveryMethod: delivery_method,
    searchText,
    uf,
    size: perPage,
    from: (current - 1) * perPage,
  };
};

const buildExportToastMessage = () => {
  const dateFormatted = Moment().format('HH:mm[h]');
  const suffixWithLink = "<a href='/order/files/transactions'><strong><u>seus arquivos</u></strong></a>";
  return `O relatório foi enviado para a fila de geração às ${dateFormatted} e estará pronto em alguns instantes nos ${suffixWithLink}.`;
};

export default {
  getTransactionsTable({ commit }, oParams = {}) {
    const params = buildTransactionParamsPayload(oParams);
    return GraphQlClient.query(
      `query(
        $isTest: Boolean
        $start: String
        $end: String
        $size: Int
        $from: Int
        $shipmentOrderVolumeState: [String]
        $logisticProvider: [Int]
        $performanceLp: [String]
        $platform: [String]
        $salesChannel: [String]
        $deliveryMethod: [Int]
        $uf: [String]
        $searchText: String) {
        transactionsV2List(
          isTest: $isTest
          dateStart: $start
          dateEnd: $end
          shipmentOrderVolumeState: $shipmentOrderVolumeState
          logisticProvider: $logisticProvider
          performanceLp: $performanceLp
          platform: $platform
          salesChannel: $salesChannel
          deliveryMethod: $deliveryMethod
          uf: $uf
          searchText: $searchText
          size: $size
          from: $from
        ) {
          total
          result {
            external_order_numbers {
              sales
            }
            client_id
            created
            order_number
            marketplace_order_number
            volumes {
              tracking_code
              invoice {
                number
              }
            }
            sales_channel
            delivered
            shipment_order_id
            warehouse_id
            shipped_date
            end_customer {
              full_name
              first_name
              last_name
              email
              federal_tax_payer_id
              shipping {
                city
                state
              }
            }
            delivery_method {
              logistic_provider {
                code
                name
                id
              }
              name
              id
              type
            }
            estimated_delivery_date
            estimated_delivery_date_lp
            shipment_order_volume_state {
              code
              localized
            }
            performance {
              code
              localized
            }
            performance_lp {
              code
              localized
            }
          }
        }
      }`, params)
    .then(res => Promise.resolve(res.data.transactionsV2List))
    .catch(err => Promise.reject(err));
  },
  getTransactionsFilters({ commit }, oParams = {}) {
    const params = buildTransactionParamsPayload(oParams);
    return GraphQlClient.query(
      `query(
        $isTest: Boolean
        $start: String
        $end: String
        $size: Int
        $from: Int
        $shipmentOrderVolumeState: [String]
        $logisticProvider: [Int]
        $performanceLp: [String]
        $platform: [String]
        $salesChannel: [String]
        $deliveryMethod: [Int]
        $uf: [String]
        $searchText: String) {
        transactionsV2Summary(
          isTest: $isTest
          dateStart: $start
          dateEnd: $end
          shipmentOrderVolumeState: $shipmentOrderVolumeState
          logisticProvider: $logisticProvider
          performanceLp: $performanceLp
          platform: $platform
          salesChannel: $salesChannel
          deliveryMethod: $deliveryMethod
          uf: $uf
          searchText: $searchText
          size: $size
          from: $from
        ) {
          total
          filters {
            shipment_order_volume_state_code {
              name
              localized
              total
            }
            sales_channel {
              name
              total
            }
            logistic_provider {
              id
              name
              total
            }
            delivery_method {
              id
              name
              total
            }
            performance_lp {
              name
              localized
              total
            }
            platform {
              name
              total
            }
            uf {
              name
              total
            }
            warehouse {
              id
              name
              total
            }
          }
        }
      }`, params)
    .then(res => Promise.resolve(res.data.transactionsV2Summary))
    .catch(err => Promise.reject(err));
  },
  exportToExcel({ commit }, oParams = {}) {
    commit('toogleLoadingExport', true);

    const {
      start = '',
      end = '',
    } = oParams.dates;

    const {
      shipment_order_volume_state_code = [],
      logistic_provider = [],
      performance_lp = [],
      platform = [],
      sales_channel = [],
      delivery_method = [],
      uf = [],
      searchText = '',
    } = oParams.slcFilter;

    const params = {
      start,
      end,
      shipmentOrderVolumeState: shipment_order_volume_state_code,
      logisticProvider: logistic_provider,
      performanceLp: performance_lp,
      platform,
      salesChannel: sales_channel,
      deliveryMethod: delivery_method,
      searchText,
      uf,
    };

    return GraphQlClient.query(
      `query(
        $start: String
        $end: String
        $shipmentOrderVolumeState: [String]
        $logisticProvider: [Int]
        $performanceLp: [String]
        $platform: [String]
        $salesChannel: [String]
        $deliveryMethod: [Int]
        $uf: [String]
        $searchText: String) {
        transactionsExport(
          dateStart: $start
          dateEnd: $end
          shipmentOrderVolumeState: $shipmentOrderVolumeState
          logisticProvider: $logisticProvider
          performanceLp: $performanceLp
          platform: $platform
          salesChannel: $salesChannel
          deliveryMethod: $deliveryMethod
          uf: $uf
          searchText: $searchText
        ) {
          status
        }
      }`, params)
    .then(({ data }) => {
      commit('toogleLoadingExport', false);
      ScToast.open({ message: buildExportToastMessage(), duration: 10000, type: 'is-success' });
      Promise.resolve(data);
    })
    .catch((err) => {
      commit('toogleLoadingExport', false);
      return Promise.resolve(err);
    });
  },
  getWarehouses({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query {
      warehouses {
        id
        official_name
        code
        federal_tax_payer_id
        address {
          zip_code
          state_code
        }
      }
    }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { warehouses = [] } = data || {};
        commit('toggleLoading', false);
        commit('setWarehouses', warehouses);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions-elastic/store/actions.js